import { Outlet } from 'react-router-dom'

export default function Blank( props ) {
  return (
    <Outlet />
  )
}
